/**
 * KAN-950: videos of the cabinet section of the current page.
 *
 * The section comes from the registry data (TutorialEntry.section), not from
 * the slug. Titles and durations are taken from the "Помощь" content
 * (content.json); a video missing there keeps the registry title and has no
 * duration. Hidden entries are never offered.
 */
import { HELP_ITEMS, type HelpItem } from './content';
import { buildVideoUrl, TUTORIALS, type TutorialEntry } from './registry';

export interface SectionVideo {
  slug: string;
  title: string;
  /** Seconds, when known from content.json. */
  duration?: number;
  videoUrl: string;
}

/**
 * Videos of the section the given slug belongs to, in registry order.
 * An entry without section gives a list of itself only; an unknown or hidden
 * slug gives an empty list.
 */
export function sectionVideos(
  slug: string,
  registry: TutorialEntry[] = TUTORIALS,
  helpItems: HelpItem[] = HELP_ITEMS
): SectionVideo[] {
  const visible = registry.filter((entry) => !entry.hidden);
  const current = visible.find((entry) => entry.slug === slug);
  if (!current) return [];
  const members = current.section
    ? visible.filter((entry) => entry.section === current.section)
    : [current];
  const helpBySlug = new Map(helpItems.map((item) => [item.slug, item]));
  return members.map((entry) => {
    const help = helpBySlug.get(entry.slug);
    return {
      slug: entry.slug,
      title: help?.title ?? entry.title,
      duration: help?.duration,
      videoUrl: buildVideoUrl(entry.slug),
    };
  });
}
